import { PriceIntervalEnum } from "@finway-group/shared/lib/models"
import { Card, Col, Row, Tag } from "antd"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"

import { DollarSignInvoiceIcon } from "Components/icons"
import { IconBackground } from "Components/icons/iconBackground"

interface BillingSettingsPeriodCardProps {
    subscriptionInterval: PriceIntervalEnum
    subStartDate: Date
    subEndDate: Date
    contractStartDate: Date
}

export const BillingSettingsPeriodCard = ({ subscriptionInterval, subStartDate, subEndDate, contractStartDate }: BillingSettingsPeriodCardProps) => {
    const { t } = useTranslation()

    const isTrial = contractStartDate && moment(contractStartDate).isAfter(subStartDate)

    return (
        <Card>
            <Row gutter={[16, 16]}>
                <Col flex={1} className="flex items-center text-lg text-primary space-x-10">
                    <IconBackground>
                        <DollarSignInvoiceIcon />
                    </IconBackground>
                    <p>{t("label:payment_settings.billing_period")}</p>
                    {isTrial && (
                        <Tag color="blue" className="ml-10">
                            {t("label:payment_settings.trial")}
                        </Tag>
                    )}
                </Col>
                <Col flex={1} className="flex justify-end items-center text-xl font-semibold text-primary">
                    {t(`label:payment_settings.intervals.${PriceIntervalEnum[subscriptionInterval].toLowerCase()}`)}
                </Col>
            </Row>
            <Row>
                <Col className="flex items-center text-gray-900">
                    {moment(subStartDate).format("L")} - {!isTrial ? moment(subEndDate).subtract(1, "days").format("L") : moment(contractStartDate).subtract(1, "days").format("L")}
                </Col>
            </Row>
        </Card>
    )
}
